<template>
  <FixedTopBanner v-if="showAlert" :enabled="true">
    <v-alert dark color="orange">
      <v-row align="center">
        <v-col cols="auto">
          <v-row class="mx-2" :style="{ width: '110px' }" justify="center">
            <div v-if="showSuccess">
              <v-icon size="64">
                eva-checkmark-circle-2
              </v-icon>
            </div>
            <div v-else-if="hasSessionTimeLeft" class="text-h3">
              {{ formattedRemainingTime }}
            </div>
            <div v-else>
              <v-progress-circular size="56" indeterminate />
            </div>
          </v-row>
        </v-col>
        <v-col class="pt-4 pb-1 text-h5 font-weight-regular">
          <p class="mb-1">
            Atenção! Por segurança, você será desconectado(a) por inatividade em
            breve.
          </p>
          <p>Movimente seu mouse para reiniciar o temporizador.</p>
        </v-col>
      </v-row>
    </v-alert>
  </FixedTopBanner>
</template>

<script>
import FixedTopBanner from "@/components/ui/fixed_top_banner.vue";

import { formatDuration } from "@/components/auth/session_expiration_status/formatDuration.js";

const UPDATE_REMAINING_TIME_MS =  1000;
const ALERT_PERSISTENCE_TIME_MS = 2500;

export default {
  name: "AuthSessionExpirationStatus",
  components: { FixedTopBanner },
  data() {
    return {
      formattedRemainingTime: "breve",
      sessionTimeLeftMs: null,
      timeMonitorInterval: null,
      keepActive: false,
      successMessageTimer: null,
      showSuccess: false,
    };
  },
  created() {
    this.startTimeMonitor();
  },
  beforeDestroy() {
    clearInterval(this.timeMonitorInterval);
  },
  apollo: {
    sessionExpirationNotificationTimeSetting: {
      query: require("@/graphql/system_settings/system_setting.gql"),
      fetchPolicy: "no-cache",
      update({ systemSetting }) {
        this.$store.dispatch(
          "authentication/setSessionTimeoutNotification",
          systemSetting.value
        );
      },
      variables: {
        name: "session_expiration_notification_time",
      },
      skip() {
        return !this.$store.state.authentication.user;
      },
    },
  },
  computed: {
    showAlert() {
      if (!this.isActionCableConnected) return false;
      if (this.showSuccess) return true;
      if (!this.isIdle) return false;
      if (!this.sessionTimeLeftMs) return false;

      return this.isCloseToSessionTimeout;
    },
    isIdle() {
      return this.$store.state.inactivity.idle;
    },
    isCloseToSessionTimeout() {
      return this.$store.getters["authentication/isCloseToSessionTimeout"];
    },
    hasSessionTimeLeft() {
      return this.sessionTimeLeftMs > 0;
    },
    isActionCableConnected() {
      return this.$store.state.actionCable.isOpen;
    },
  },
  watch: {
    isIdle(isIdle) {
      if (isIdle) return;
      if (!this.isCloseToSessionTimeout) return; // don't show if user wasn't seeing the warning already

      this.showSuccessTemporarily();
    },
    async hasSessionTimeLeft(hasTimeLeft) {
      if (hasTimeLeft) return;

      await this.signOutUser();
    },
  },
  methods: {
    startTimeMonitor() {
      this.monitorTime();

      this.timeMonitorInterval = setInterval(
        () => this.monitorTime(),
        UPDATE_REMAINING_TIME_MS
      );
    },
    async monitorTime() {
      this.$store.dispatch("authentication/updateSessionTimeLeft");

      this.assignRemainingTime();
      await this.refreshTokenIfNeeded();
    },
    assignRemainingTime() {
      this.sessionTimeLeftMs = this.$store.state.authentication.sessionTimeLeftMs;
      this.formattedRemainingTime = formatDuration(this.sessionTimeLeftMs);
    },
    showSuccessTemporarily() {
      clearTimeout(this.successMessageTimer);

      this.showSuccess = true;

      this.successMessageTimer = setTimeout(
        () => (this.showSuccess = false),
        ALERT_PERSISTENCE_TIME_MS
      );
    },
    async refreshTokenIfNeeded() {
      if (!this.isCloseToSessionTimeout) return;
      if (this.isIdle) return;

      await this.$store.dispatch("authentication/refreshToken");
    },
    async signOutUser() {
      await this.$store.dispatch("authentication/signOut");
      await this.$router.push("/login");
    },
  },
};
</script>

<style scoped></style>
